import { openModal } from '@inexture/modals';
import { ModalProps, ScrollAreaAutosize } from '@inexture/core';

export const popupModal = (data?: Partial<ModalProps>):  ReturnType<typeof openModal>  => {
  return openModal({
    centered: true,
    closeOnClickOutside: false,
    overlayProps: { blur: 3 },
    transitionProps: { transition: 'pop', duration: 200 },
    children: data?.children,
    withCloseButton: true,
    withinPortal: true,
    scrollAreaComponent: ScrollAreaAutosize,
    size: 'xl',
    styles: {
      header: {
        boxShadow: 'var(--mantine-shadow-sm)'
      },
      title: {
        fontWeight: 800,
        letterSpacing: '1px'
      },
      body: {
        padding: '20px'
      }
    },
    ...data
  } as ModalProps);
};
